import React from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { IconEdit } from '../../assets/icons';
import { LocalVehicle } from '..';
import { TranslationUtils } from '../../utils';

interface VehiclePanelListProps {
    vehicles: LocalVehicle[];
    onEditVehicleClick: (vehicle: LocalVehicle) => void;
    onEditVehicleKeyDown: (e: any, vehicle: LocalVehicle) => void;
}

export const VehiclePanelList: React.FC<VehiclePanelListProps> = (props) => {
    const { vehicles, onEditVehicleClick, onEditVehicleKeyDown } = props;

    const renderCell = (id: number, value: string, type: string, className: string) => {
        const idTag = type === 'plate' ? `plate-${id}` : `state-${id}`;
        return (
            <div className={className}>
                <span id={idTag} className="title-vehicle text-vehicle-overflow">
                    {value}
                </span>
            </div>
        );
    };

    return (
        <React.Fragment>
            <div className="row ml-2">
                <div className="col-4">
                    <span className="title-vehicle bold ">{TranslationUtils.get('license_plate')}</span>
                </div>
                <div className="col-5">
                    <span className="title-vehicle bold">{TranslationUtils.get('state_province')}</span>
                </div>
                <div className="item-next-vehicle" />
            </div>
            <Card>
                <ListGroup variant="flush">
                    {vehicles.map((vehicle, index) => (
                        <ListGroup.Item key={vehicle.id}>
                            <div className="row">
                                {renderCell(index, vehicle.plate, 'plate', 'col-4 vehicle-cell-wrap ml-1')}
                                {renderCell(index, vehicle.stateName, 'state', 'col-5 vehicle-cell-wrap ml-1')}
                                <div className="col 2">
                                    <a
                                        title={`${TranslationUtils.get('edit_vehicle_title')} ${vehicle.plate}`}
                                        id={`link-edit-vehicle-${index}`}
                                        tabIndex={0}
                                        role="button"
                                        onClick={() => onEditVehicleClick(vehicle)}
                                        onKeyDown={(e) => onEditVehicleKeyDown(e, vehicle)}
                                    >
                                        <IconEdit className="icon-invite-vehicle pointer float-right" />
                                    </a>
                                </div>
                            </div>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </Card>
        </React.Fragment>
    );
};
